export const translateType = (type: string, context_id: string) => {
  if (type === 'locais') return { place_id: context_id };
  else if (type === 'grupos') return { group_id: context_id };
  else return { class_id: context_id };
};
